import moment from 'moment';
import {DATE_TIME_FORMAT} from '../components/helpers/DateHelper';
import ReactSelectFormatter from "./ReactSelectFormatter";

class CoursesParamsFormatter {
    static format(course, userId) {
        return {
            id: course.id,
            contactPersonId: course.contactPersonId,
            startDate: this.getUnixStamp(course.startDate),
            // TODO Remove when frontend validation will be ready
            endDate: moment(course.endDate, DATE_TIME_FORMAT).isBefore(moment(course.startDate, DATE_TIME_FORMAT))
                ? this.getUnixStamp(course.startDate)
                : this.getUnixStamp(course.endDate),
            price: course.amount,
            currencyId: course.currencyId || 1,
            priceTypeId: course.priceTypeId || 3,
            categoryIds: course.categoryIds || [],
            additionalInformation: course.additionalInformation,
            description: course.description,
            registrationLink: course.registrationLink,
            isStatistic: course.isStatistic,
            regionId: course.regionId,
            name: course.name,
            creatorId: userId,
            typeId: course.typeId,
            isCommentsAllowed: !!course.isCommentsAllowed,
            youtubeId: course.youtubeId,
            vimeoId: course.vimeoId,
            images: course.images,
            files: course.files,
            defaultImageIds: course.defaultImageIds,
            defaultFileIds: course.defaultFileIds,
            countryId: course.countryId,
            municipalityId: course.municipalityId,
            addressId: course.addressId,
            city: course.city,
            postalCode: course.postalCode,
            latitude: course.latitude,
            longitude: course.longitude,
            showOnMaps: course.showOnGoogleMaps || false,
        };
    }

    static convertToForm(course) {
        let formattedCourse = Object.assign({}, course);

        if(formattedCourse.images instanceof Object) {
            if(!(formattedCourse.images instanceof Array)) {
                formattedCourse.images = Object.values(formattedCourse.images);
            }

            formattedCourse.defaultImages = formattedCourse.images;
            formattedCourse.defaultImageIds = formattedCourse.defaultImages.map(image => image.id);
        }
        else {
            formattedCourse.images = formattedCourse.defaultImages = formattedCourse.defaultImageIds = [];
        }

        if(formattedCourse.files instanceof Object) {
            if(!(formattedCourse.files instanceof Array)) {
                formattedCourse.files = Object.values(formattedCourse.files);
            }

            formattedCourse.defaultFiles = formattedCourse.files;
            formattedCourse.defaultFileIds = formattedCourse.defaultFiles.map(file => file.id);
        }
        else {
            formattedCourse.files = formattedCourse.defaultFiles = formattedCourse.defaultFileIds = [];
        }

        return {
            id: formattedCourse.id,
            contactPersonId: (formattedCourse.contactPerson && formattedCourse.contactPerson.id) ? formattedCourse.contactPerson.id : null,

            startDate: moment.unix(formattedCourse.startDate).format(DATE_TIME_FORMAT),
            endDate: moment.unix(formattedCourse.endDate).format(DATE_TIME_FORMAT),

            amount: formattedCourse.price !== undefined ? formattedCourse.price : null,
            currencyId: (formattedCourse.currency !== undefined && formattedCourse.currency.id) ? formattedCourse.currency.id : 1,
            priceTypeId: (formattedCourse.priceType !== undefined && formattedCourse.priceType.id) ? formattedCourse.priceType.id : 3,

            categoryIds: formattedCourse.categories.map(category => category.id) || [],
            additionalInformation: formattedCourse.additionalInformation,
            description: formattedCourse.description,
            youtubeId: formattedCourse.youtubeId || '',
            vimeoId: formattedCourse.vimeoId || '',
            registrationLink: formattedCourse.registrationLink,
            isStatistic: formattedCourse.isStatistic,
            name: formattedCourse.name,
            typeId: formattedCourse.typeId,
            images: [],
            defaultImageIds: formattedCourse.defaultImageIds,
            defaultImages: formattedCourse.defaultImages,
            files: [],
            defaultFileIds: formattedCourse.defaultFileIds,
            defaultFiles: formattedCourse.defaultFiles,

            countryId: formattedCourse.location.country !== undefined ? formattedCourse.location.country.id : 1,
            regionId: formattedCourse.location.regionId,
            municipalityId: formattedCourse.location.municipalityId,
            addressId: formattedCourse.location.addressId,
            latitude: formattedCourse.location.latitude,
            longitude: formattedCourse.location.longitude,
            city: formattedCourse.location.city,
            postalCode: formattedCourse.location.postalCode,
            address: formattedCourse.location.address,
            showOnGoogleMaps: formattedCourse.showOnMaps,
        };
    }

    /**
     *
     * @param {string} dateString
     * @returns {integer}
     */
    static getUnixStamp(dateString) {
        return moment(dateString, DATE_TIME_FORMAT).unix();
    }
}

export default CoursesParamsFormatter;


// WEBPACK FOOTER //
// ./web/src/services/CoursesParamsFormatter.js